import { render } from "./KskQwertyKeyboard.vue?vue&type=template&id=7a4504d3&scoped=true"
import script from "./KskQwertyKeyboard.vue?vue&type=script&lang=js"
export * from "./KskQwertyKeyboard.vue?vue&type=script&lang=js"

import "./KskQwertyKeyboard.vue?vue&type=style&index=0&id=7a4504d3&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4504d3"]])

export default __exports__